import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useAppointmentRequestStore = defineStore('appointmentRequest', {
  state: () => ({
    requests: {},
    unsubs: []
  }),
  persist: { paths: ['requests'] },
  getters: {
    pendingRequests(state) {
      return Object.entries(state.requests)
        .map(([id, value]) => ({ id, ...value }))
        .sort((a, b) => (a.date || 0) - (b.date || 0));
    }
  },
  actions: {
    upsert({ id, value }) {
      this.requests = { ...this.requests, [id]: value };
    },
    remove(id) {
      const requests = { ...this.requests };
      delete requests[id];
      this.requests = requests;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.requests = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      let snapshotQuery = collection(firestore, 'appointmentRequests');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('AppointmentRequest - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    }
  }
});
